(() => {
  const init = (finder) => {
    if (!finder || finder.dataset.ready) return;
    finder.dataset.ready = 'true';
    const setActive = (selector, button) => {
      finder.querySelectorAll(selector).forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
    };
    const roomConfig = {
      Small: { range: 'up to 75 sq ft', gentle: 36, balanced: 36, strong: 42 },
      Medium: { range: '76-176 sq ft', gentle: 42, balanced: 52, strong: 60 },
      Large: { range: '176-350 sq ft', gentle: 52, balanced: 60, strong: 70 },
      'Open Plan': { range: '350+ sq ft', gentle: 60, balanced: 70, strong: 82 },
    };
    const maxCfm = { 36: 3971, 42: 4528, 52: 5870.79, 60: 6411.99, 70: 8852.31, 82: 10569 };
    let variants = [];
    try {
      variants = JSON.parse(finder.querySelector('[data-xp-size-variants]')?.textContent || '[]');
    } catch (error) {
      console.error('Unable to read 301L size variants.', error);
    }
    const variantSize = (value) => Number.parseInt(String(value || '').match(/\d+/)?.[0] || '', 10);
    const normalize = (value) => String(value || '').trim().toLowerCase();
    const updateColorImage = () => {
      const colorButton = finder.querySelector('[data-xp-color].is-active');
      const media = finder.querySelector('.xp-recommendation__media');
      const image = media?.querySelector('img');
      if (!image) return;
      const sceneImage = colorButton?.dataset.xpColorImage || media.dataset.xpFallbackImage;
      if (!sceneImage) return;
      image.src = sceneImage;
      image.removeAttribute('srcset');
      if (colorButton?.dataset.xpColor) image.alt = `${colorButton.dataset.xpColor} fan scene`;
    };
    const update = () => {
      const room = finder.querySelector('[data-xp-room].is-active');
      const height = finder.querySelector('[data-xp-height].is-active');
      const airflowButton = finder.querySelector('[data-xp-airflow].is-active');
      if (!room || !height || !airflowButton) return;
      const airflowText = airflowButton.textContent.trim();
      const airflow = airflowButton.dataset.xpAirflow || 'balanced';
      const config = roomConfig[room.dataset.roomLabel];
      const size = config[airflow];
      const downrod = height.dataset.downrod;
      finder.querySelector('[data-xp-recommend-size]').textContent = `${size} inch`;
      finder.querySelector('[data-xp-room-result]').textContent = `Ideal for rooms ${config.range}`;
      finder.querySelector('[data-xp-downrod-result]').textContent = `Recommended downrod: ${downrod}`;
      finder.querySelector('[data-xp-airflow-result]').textContent = `${airflowText} airflow preference`;
      finder.querySelector('[data-xp-cfm-result]').textContent = `Maximum airflow: ${Math.round(maxCfm[size]).toLocaleString('en-US')} CFM`;
      const selectedColor = finder.querySelector('[data-xp-color].is-active')?.dataset.xpColor || '';
      const matchingVariants = variants.filter((variant) => variantSize(variant.size) === size);
      const colorVariants = selectedColor
        ? matchingVariants.filter((variant) => normalize(variant.color) === normalize(selectedColor))
        : matchingVariants;
      const recommendedVariant = colorVariants[0];
      const article = size === 82 ? 'an' : 'a';
      const variantInput = finder.querySelector('[data-xp-variant-id]');
      const addButton = finder.querySelector('[ref="addToCartButton"]');
      const addButtonText = addButton?.querySelector('.add-to-cart-text__content > span > span');
      const canPurchase = Boolean(recommendedVariant?.available);
      if (recommendedVariant) {
        if (variantInput) {
          variantInput.value = recommendedVariant.id;
          variantInput.disabled = !canPurchase;
        }
      } else {
        if (variantInput) {
          variantInput.value = '';
          variantInput.disabled = true;
        }
      }
      if (addButton) addButton.disabled = !canPurchase;
      if (addButtonText) {
        addButtonText.textContent = canPurchase
          ? finder.dataset.xpAddLabel || 'Add to cart'
          : finder.dataset.xpUnavailableLabel || 'Unavailable';
      }
      const result = finder.querySelector('[data-xp-result]');
      if (canPurchase) {
        result.classList.remove('is-unavailable');
        result.textContent = `✓ For ${config.range}, ${airflowText.toLowerCase()} airflow recommends ${article} ${size}-inch fan with a ${downrod}.`;
      } else {
        const unavailableTemplate = finder.dataset.xpUnavailableMessage || '{color} is currently unavailable in {size} inch.';
        result.classList.add('is-unavailable');
        result.textContent = unavailableTemplate
          .replaceAll('{color}', selectedColor || 'This color')
          .replaceAll('{size}', String(size));
      }
    };
    finder.querySelectorAll('[data-xp-room]').forEach((button) => button.addEventListener('click', () => { setActive('[data-xp-room]', button); update(); }));
    finder.querySelectorAll('[data-xp-height]').forEach((button) => button.addEventListener('click', () => { setActive('[data-xp-height]', button); update(); }));
    finder.querySelectorAll('[data-xp-airflow]').forEach((button) => button.addEventListener('click', () => { setActive('[data-xp-airflow]', button); update(); }));
    finder.querySelectorAll('[data-xp-color]').forEach((button) => button.addEventListener('click', () => {
      setActive('[data-xp-color]', button);
      finder.querySelectorAll('[data-xp-color]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      updateColorImage();
      update();
    }));
    const initialColor = finder.querySelector('[data-xp-color].is-active') || finder.querySelector('[data-xp-color]');
    if (initialColor) {
      setActive('[data-xp-color]', initialColor);
      finder.querySelectorAll('[data-xp-color]').forEach((item) => item.setAttribute('aria-pressed', String(item === initialColor)));
    }
    updateColorImage();
    update();
  };
  const initAll = (scope = document) => scope.querySelectorAll?.('[data-xp-size-finder]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
